import { defineComponent as f, mergeModels as v, useModel as h, computed as C, watch as k, onBeforeUnmount as V, createElementBlock as i, openBlock as r, createBlock as w, Teleport as y, createVNode as d, mergeProps as z, withCtx as u, Transition as S, createCommentVNode as B, normalizeClass as E, normalizeStyle as L, renderSlot as $ } from "vue";
import { _ as g } from "./UiOverlay.vue_vue_type_script_setup_true_lang-DkZL3VLh.js";
/* empty css                                                   */
const m = "ui-drawer__lock-scroll", N = /* @__PURE__ */ f({
  __name: "UiDrawer",
  props: /* @__PURE__ */ v({
    direction: { default: "rtl" },
    size: { default: "50%" },
    drawerClass: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const l = h(a, "modelValue"), c = a, t = C(() => ["rtl", "ltr"].includes(c.direction) ? "horizontal" : "vertical");
    function p() {
      document.querySelector("html")?.classList.add(m);
    }
    function s() {
      document.querySelector("html")?.classList.remove(m);
    }
    return k(l, () => {
      l.value ? p() : s();
    }), V(() => {
      s();
    }), (e, o) => (r(), i("div", null, [
      (r(), w(y, { to: "body" }, [
        d(g, z({ ...e.$attrs }, {
          modelValue: l.value,
          "onUpdate:modelValue": o[0] || (o[0] = (n) => l.value = n),
          onClick: o[1] || (o[1] = (n) => l.value = !1)
        }), {
          default: u(() => [
            d(S, { appear: "" }, {
              default: u(() => [
                l.value ? (r(), i("div", {
                  key: 0,
                  style: L({
                    width: t.value === "horizontal" ? e.size : "100%",
                    height: t.value === "vertical" ? e.size : "100%"
                  }),
                  class: E(["ui-drawer", [e.direction, t.value, e.drawerClass]])
                }, [
                  $(e.$slots, "default")
                ], 6)) : B("", !0)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 16, ["modelValue"])
      ]))
    ]));
  }
});
export {
  N as _
};
